import { useEffect } from "react";

const useLocalStorage = (key: string, value: any) => {
  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);
};

export default useLocalStorage;
